import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
function PrivacyContent() {
  return <>
      <p className="text-gray-400 italic" data-id="element-44">Última actualización: Marzo 2025</p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-45">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-46">
        Al adquirir nuestro Blueprint "Teen Pro", recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito en nuestros servidores.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-47">
        2. Uso de la Información
      </h3>
      <p data-id="element-48">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-49">
        <li data-id="element-50">Procesar y entregar tu compra del Blueprint.</li>
        <li data-id="element-51">
          Enviarte actualizaciones relacionadas con el producto adquirido.
        </li>
        <li data-id="element-52">Brindarte soporte al cliente si lo solicitas.</li>
      </ul>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-53">
        3. Protección de Datos
      </h3>
      <p data-id="element-54">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Utilizamos cifrado SSL para todas las
        transacciones y almacenamos los datos en servidores seguros.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-55">
        4. Compartir Información
      </h3>
      <p data-id="element-56">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de pago
        necesarios para procesar tu transacción.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-57">5. Cookies</h3>
      <p data-id="element-58">
        Nuestro sitio utiliza cookies esenciales para el funcionamiento del
        sitio y cookies analíticas para mejorar tu experiencia. Puedes
        desactivar las cookies en la configuración de tu navegador.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-59">
        6. Menores de Edad
      </h3>
      <p data-id="element-60">
        Nuestro producto está diseñado para adolescentes, pero las compras deben
        ser realizadas por un padre o tutor legal mayor de 18 años. No
        recopilamos intencionalmente información de menores de 13 años.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-61">7. Tus Derechos</h3>
      <p data-id="element-62">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, envíanos un correo
        electrónico.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 italic" data-id="element-63">Última actualización: Marzo 2025</p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-64">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-65">
        Al acceder y comprar el Blueprint "Teen Pro", aceptas estos términos y
        condiciones en su totalidad. Si no estás de acuerdo con alguna parte, no
        debes utilizar este sitio ni adquirir el producto.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-66">
        2. Descripción del Producto
      </h3>
      <p data-id="element-67">
        "Teen Pro" es un producto digital educativo (Blueprint/guía) sobre
        educación financiera básica. No constituye asesoramiento financiero
        profesional, legal ni fiscal. El contenido es únicamente con fines
        educativos e informativos.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-68">
        3. Uso del Producto
      </h3>
      <p data-id="element-69">
        Al adquirir el Blueprint, recibes una licencia personal e intransferible
        para uso individual. Queda prohibido:
      </p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-70">
        <li data-id="element-71">Reproducir, distribuir o revender el contenido.</li>
        <li data-id="element-72">Compartir el acceso con terceros.</li>
        <li data-id="element-73">Utilizar el contenido con fines comerciales sin autorización.</li>
      </ul>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-74">
        4. Política de Reembolso
      </h3>
      <p data-id="element-75">
        Ofrecemos una garantía de devolución del 100% del dinero dentro de los
        primeros 7 días posteriores a la compra. Para solicitar un reembolso,
        debes contactarnos por correo electrónico dentro de dicho plazo.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-76">
        5. Descargo de Responsabilidad
      </h3>
      <p data-id="element-77">
        Los resultados mencionados en experiencias y ejemplos son ilustrativos y
        no garantizan resultados específicos. El éxito financiero depende de
        múltiples factores individuales. No somos responsables de decisiones
        financieras tomadas basándose en el contenido del Blueprint.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-78">
        6. Menores de Edad
      </h3>
      <p data-id="element-79">
        Las compras deben ser realizadas por personas mayores de 18 años. Si
        eres menor de edad, un padre o tutor legal debe realizar la compra en tu
        nombre. Cualquier actividad de inversión mencionada en el Blueprint
        requiere supervisión parental y cuentas custodia.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-80">
        7. Propiedad Intelectual
      </h3>
      <p data-id="element-81">
        Todo el contenido del Blueprint "Teen Pro", incluyendo textos, gráficos,
        diseños y marca, es propiedad exclusiva de Teen Pro y está protegido por
        las leyes de propiedad intelectual aplicables.
      </p>

      <h3 className="text-white font-bold text-base mt-4" data-id="element-82">8. Modificaciones</h3>
      <p data-id="element-83">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán efectivos inmediatamente después de su
        publicación en este sitio.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 px-4 text-center text-sm border-t border-white/5 mt-20" data-id="element-84">
        <p className="text-gray-500 max-w-3xl mx-auto leading-relaxed" data-id="element-85">
          © 2025 Teen Pro. Todos los derechos reservados. Este sitio web y el
          producto 'Teen Pro' son exclusivamente de carácter educativo e
          informativo. No constituye asesoría financiera, legal, contable o de
          inversión profesional. Los resultados mencionados son ilustrativos y
          pueden variar según la implementación y contexto de cada usuario. Este
          sitio no forma parte de Facebook, Instagram o Meta Platforms, Inc.
          Meta no respalda ni patrocina este producto de ninguna manera.
        </p>
        <div className="mt-4 flex items-center justify-center gap-4" data-id="element-86">
          <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-[#39FF14] transition-colors duration-200 underline underline-offset-2" data-id="element-87">
            Política de Privacidad
          </button>
          <span className="text-gray-700" data-id="element-88">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-[#39FF14] transition-colors duration-200 underline underline-offset-2" data-id="element-89">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-90">
        <PrivacyContent data-id="element-91" />
      </LegalModal>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-92">
        <TermsContent data-id="element-93" />
      </LegalModal>
    </>;
}